// extracted by mini-css-extract-plugin
export default {"btnBox":"ProductDetailPage_btnBox__pCpbC","button":"ProductDetailPage_button__vq6pS"};